import { TAxiosError } from '@mgm/common/types';
import { useRequest } from '@mgm/common/lib';
import { CONTROLLERS } from '../utils/enums';
import { TGetShopifyProductsByLocation, TTransferVariantReq } from '../types/responses/inventory.type';
import { BASE_URL } from '../../config';
import { getIdToken } from '../utils/helpers';

export function InventoryController() {
  const { axiosRequest, initRequestOptions } = useRequest(BASE_URL);

  const controllerName = CONTROLLERS.INVENTORY;

  const getAllProductsByLocationId = async <T>(data: TGetShopifyProductsByLocation): Promise<T | { success: boolean; error: TAxiosError }> => {
    const options = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });
    return axiosRequest(`${controllerName}/get`, options);
  };

  const transferVariantQuntity = async <T>(data: TTransferVariantReq): Promise<T | { success: boolean; error: TAxiosError }> => {
    const options = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });
    return axiosRequest(`${controllerName}/transfer_products`, options);
  };

  return {
    getAllProductsByLocationId,
    transferVariantQuntity,
  };
}
